import React, { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function UploadButton({ onUploaded, accept, testId }) {
  const { authHeaders } = useAuth();
  const { t } = useLang();
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await axios.post(`${API}/admin/upload`, formData, {
        headers: authHeaders(),
        withCredentials: true,
      });
      onUploaded(data.url, data.alt_text);
      if (data.alt_text) {
        toast.success(`${t("admin.projects.upload_success")} ${t("admin.projects.alt_text_label")}: "${data.alt_text}"`, { duration: 8000 });
      } else {
        toast.success(t("admin.projects.upload_success"));
      }
    } catch (err) {
      console.warn("Upload failed:", err?.response?.status ?? err?.message);
      toast.error(err?.response?.data?.detail || t("admin.projects.upload_failed"));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        className="hidden"
        data-testid={`${testId}-file-input`}
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        data-testid={testId}
        title={t("admin.projects.upload_file")}
        className="w-9 h-9 shrink-0 border border-white/15 hover:border-white flex items-center justify-center transition-colors disabled:opacity-50"
      >
        {uploading ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} strokeWidth={1.5} />}
      </button>
    </>
  );
}
